<template>
  <div>
    <div class="modal-header has-background-info-light">
      <h2 class="window-header subtitle">{{ title }}</h2>
    </div>
    <div class="box">
      <!-- ime -->
      <div class="columns">
        <div class="column has-text-centered"><label>Ime:</label></div>
        <div class="column is-four-fifths">
          <p class="has-text-centered has-background-info-light">
            {{ employeeName }}
          </p>
        </div>
      </div>
      <!-- table logs -->
      <div class="has-text-centered has-background-info-light">
        <label>Izlasci na dan: {{ logDate }} </label>
      </div>
      <!-- Table -->
      <div class="base-demo">
        <vue-table-dynamic :params="params"></vue-table-dynamic>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDateFromTicks,
  maskIfEquealsValue,
  getLeavingReasonStringFromId,
} from "../../_helpers/arrangers";

export default {
  name: "EditOutsideEvent",

  props: {
    title: String,
    employeeName: String,
    eventsType: String,
    selectedDailyLog: Object,
  },

  data() {
    return {
      params: {
        data: [
          [
            "ndx",
            "vrijeme odlaska",
            "vrijeme dolaska",
            "tip",
            "trajanje",
            "ispravno?",
          ],
        ],
        header: "row",
        columnWidth: [
          { column: 0, width: "7%" },
          { column: 3, width: "30%" },
          { column: 5, width: "15%" },
        ],
      },
    };
  },

  computed: {
    logDate() {
      return new Date(this.selectedDailyLog.logDate).toLocaleDateString(
        "sr-latn-cs"
      );
    },
  },

  methods: {
    resetUi() {
      this.params.data = [
        ["ndx", "odlazak", "dolazak", "tip", "trajanje", "ispravno?"],
      ];
    },
    arrangeData() {
      let ndx = 1;
      console.log(this.selectedDailyLog.outsideEvent);
      if (this.eventsType == "outside") {
        this.selectedDailyLog.outsideEvent.forEach((element) => {
          console.log(element);
          this.params.data.push([
            ndx++,
            maskIfEquealsValue(
              new Date(element.departureTime).toLocaleTimeString("sr-latn-cs"),
              "01:00:00"
            ),
            maskIfEquealsValue(
              new Date(element.arrivalTime).toLocaleTimeString("sr-latn-cs"),
              "01:00:00"
            ),
            element.vehicleType == "teretno"
              ? "🚚 " + element.vehicleName + ", " + element.routeName
              : element.vehicleType == "putničko"
              ? "🚗 " + element.licensePlate
              : "🚶 " + getLeavingReasonStringFromId(element.leavingReasonId),
            maskIfEquealsValue(getDateFromTicks(element.duration), "00:00:00"),
            element.isLogicallyClosed ? "✅" : "❌",
          ]);
        });
      } else {
        this.selectedDailyLog.insideEvent.forEach((element) => {
          console.log(element);
          this.params.data.push([
            ndx++,
            maskIfEquealsValue(
              new Date(element.departureTime).toLocaleTimeString("sr-latn-cs"),
              "01:00:00"
            ),
            maskIfEquealsValue(
              new Date(element.arrivalTime).toLocaleTimeString("sr-latn-cs"),
              "01:00:00"
            ),
            element.vehicleType == "teretno"
              ? "🚚 " + element.vehicleName + ", " + element.routeName
              : element.vehicleType == "putničko"
              ? "🚗 " + element.licensePlate
              : "🚶 ",
            maskIfEquealsValue(getDateFromTicks(element.duration), "00:00:00"),
            element.isLogicallyClosed ? "✅" : "❌",
          ]);
        });
      }
    },
  },

  mounted() {
    this.resetUi();
    this.arrangeData();
  },
};
</script>
